module.exports = ":host {\n  display: block; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = 1176
// module chunks = 0